<template>
  <b-card title="Test: Certyfikowany Kurs Obsługi SKP®" class="title-inline">
    <b-overlay
      :show="loading"
      bg-color="eef0f5"
      blur="2px"
      rounded="sm"
      class="p-1"
    >
      <b-card-text>
        <course-exam-info
          v-if="examInfo"
          :styles="styles"
          v-on:onToggleExamInfo="onToggleExamInfo"
        ></course-exam-info>
        <course-exam-input-name
          v-else-if="participantName.length === 0"
          v-on:onSetParticipantName="onSetParticipantName"
          v-on:showCourse="$emit('showCourse')"
          v-on:onToggleLoading="onToggleLoading"
        ></course-exam-input-name>

        <div v-else-if="endExam">
          <div v-if="typeof examResults.pass === 'boolean'">
            <course-exam-passed
              v-if="examResults.pass"
              :styles="styles"
              :examResults="examResults"
              :participantName="participantName"
              :participantId="participantId"
              v-on:showCourse="$emit('showCourse')"
              v-on:onToggleLoading="onToggleLoading"
            ></course-exam-passed>
            <course-exam-failed
              v-else
              :styles="styles"
              :examResults="examResults"
              :participantName="participantName"
              :participantId="participantId"
              v-on:showCourse="$emit('showCourse')"
              v-on:clearParticipant="clearParticipant"
            ></course-exam-failed>
          </div>
        </div>

        <div v-else>
          <b-row class="mb-3">
            <b-col class="mr-1 py-2">
              <b-button
                class="m-auto py-2 w-50 font-size-16 text-white"
                data-toggle="modal"
                data-target="#stopExam"
              >
                Przerwij test i wybierz innego uczestnika
                <b-icon-chevron-right class="font-size-15 text-white" />
              </b-button>
              <div
                class="modal fade"
                id="stopExam"
                tabindex="-1"
                role="dialog"
                aria-labelledby="stopExamLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="stopExamLabel">
                        Czy na pewno chcesz przerwać test?
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      Klikając TAK – utracisz dotychczas udzielone odpowiedzi<br />
                      Klikając NIE – będziesz kontynuować test
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary text-white"
                        data-dismiss="modal"
                      >
                        Nie, kontynuuję
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary text-white"
                        data-dismiss="modal"
                        @click="onStopExam()"
                      >
                        Tak, kończę test
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col class="mr-1 py-2 text-right">
              Pozostały czas: {{ examTimeLeft }} min
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col class="mr-1 py-2">
              <course-exam-questions
                v-if="this.examSet.length > 0"
                :participantId="participantId"
                :examSet="examSet"
                :examImagesPath="examImagesPath"
                v-on:onToggleLoading="onToggleLoading"
                v-on:onChangeAnswer="onChangeAnswer"
                v-on:onEndExam="onEndExam"
              ></course-exam-questions>
            </b-col>
          </b-row>
        </div>
      </b-card-text>
    </b-overlay>

    <div
      class="modal fade"
      id="examTimeOut"
      tabindex="-1"
      role="dialog"
      aria-labelledby="examTimeOutLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Skończył się Twój czas na rozwiązanie testu (wynosił
            {{ Math.floor(examTimeLimit / 60) }} minut).
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary text-white"
              data-dismiss="modal"
            >
              Zakończ kurs
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import CourseExamInfo from './CourseExamInfo';
import CourseExamInputName from './CourseExamInputName';
import CourseExamQuestions from './CourseExamQuestions';
import CourseExamPassed from './CourseExamPassed';
import CourseExamFailed from './CourseExamFailed';

export default {
  name: 'CourseExam',
  components: {
    CourseExamInfo,
    CourseExamInputName,
    CourseExamQuestions,
    CourseExamPassed,
    CourseExamFailed,
  },
  created() {},
  data() {
    return {
      loading: false,
      examInfo: true,
      participantId: 0,
      participantName: '',
      examSet: {},
      examResults: {},
      examTimeLimit: 60,
      examImagesPath: '',
      endExam: false,
      examTimeCounter: 60,
      examTimeInterval: {},
    };
  },
  props: {
    styles: {},
  },
  computed: {
    examTimeLeft() {
      let date = new Date(this.examTimeCounter * 1000);
      let minutes =
        (date.getUTCMinutes() < 10 ? '0' : '') + date.getUTCMinutes();
      let seconds = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
      return minutes + ':' + seconds;
    },
  },
  methods: {
    onSetParticipantName(participantData) {
      this.participantId = participantData.participantId;
      this.participantName = participantData.participantName;
      this.examSet = participantData.examSet;
      if (participantData.examPass === 1) {
        this.onEndExam();
      } else {
        this.examTimeLimit = participantData.examTimeLimit;
        this.examImagesPath = participantData.examImagesPath;
        this.startTimeCounter(participantData.examTimeLimit);
      }
    },
    clearParticipant() {
      this.participantName = '';
      this.examSet = {};
      this.endExam = false;
    },
    startTimeCounter(timeLimit) {
      this.examTimeCounter = timeLimit;
      clearInterval(this.examTimeInterval);
      this.examTimeInterval = setInterval(() => {
        if (this.examTimeCounter > 0) {
          this.examTimeCounter--;
        } else {
          clearInterval(this.examTimeInterval);
          $('#examTimeOut')
            .modal('show')
            .on('hide.bs.modal', () => {
              this.clearParticipant();
            });
        }
      }, 1000);
    },
    onToggleLoading(loading) {
      this.loading = loading;
    },
    onChangeAnswer(answer) {
      this.examSet[answer.questionIndex].participant_answer = answer.value;
    },
    onToggleExamInfo(value) {
      this.examInfo = value;
    },
    onStopExam() {
      this.clearParticipant();
      this.$router.push('/skp/kurs-skp');
    },
    onEndExam() {
      this.endExam = true;
      this.examResults = {};
      clearInterval(this.examTimeInterval);
      this.onToggleLoading(true);
      axios
        .post('/api/course-exam/check-and-save-exam-result', {
          examAnswers: this.examSet,
          participantName: this.participantName,
        })
        .then(({ data }) => {
          this.examResults = data;
          this.onToggleLoading(false);
        })
        .catch((error) => {
          this.onToggleLoading(false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
}
</style>
